export const AUTH_LOGIN = "api/user/signin";
export const AUTH_LOGOUT = "auth/Logout";
export const AUTH_RESET = "auth/Reset";
export const AUTH_SIGNUP = "/api/journalist-approval-request";
export const AUTH_FULL_SIGNUP = "api/user/profile";
export const RESET_PASS = "/api/user/password/change";
export const VERIFY_RESET_PASS = "auth/TokenVerifcation";
export const SET_NEW_PASSWORD = "auth/SetPassword";
export const DELETE_ACCOUNT = "auth/DeleteAccount";
export const CHANGE_PASSWORD_ACCOUNT = "auth/ChangePasswordAccount";
export const FETCH_NOTIFICATION = "auth/FetchNotification";
export const UPDATE_NOTIFICATION = "auth/updateNotification";
export const FETCH_CURRENCIES = "auth/currencies";
export const JOURNALIST_APPROVAL_REQUEST = "auth/JournalistApprovalRequest";
export const RESEND_SIGNUP_EMAIL = "auth/resendSignupEmail";
export const VERIFY_RESET_PASSWORD_OTP = "auth/verifyResetPasswordOtp";
export const VERIFY_SIGNUP_EMAIL_OTP = "auth/verifySignupEmailOtp";
